import React, { useRef } from 'react'
import umang from '../images/contac.png'
import emailjs from '@emailjs/browser'
import '../style/midContact.css'

const MidContactUs = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      requirement: e.target.requirement.value,
    };

    const emailContent = `
          Name: ${formData.name}\n
          Email: ${formData.email}\n
          Phone: ${formData.phone}\n
          Requirement: ${formData.requirement}
      `;

    const emailParams = {
      to_name: 'Recipient Name',
      from_name: formData.name,
      from_email: formData.email,
      message: emailContent,
    };

    emailjs.send('service_s9yl39f', 'template_d1jwppl', emailParams, 'Ef5elHS0NNiPr2U6U')
      .then((result) => {
        console.log('Email successfully sent!', result.text);
        form.current.reset();  // Reset the form fields
        alert('Thank you I will get back to you as soon as possible ! :)');
      })
      .catch((error) => {
        console.error('There was an error sending the email:', error);
        alert('Error suring sending mail')
      });
  };
  return (
    <>
      <section className='midContac'>
        <div className='container' style={{ textAlign: 'center', marginTop: '50px' }}>
          <h3 style={{ paddingTop: '35px', color: 'white' }}>Book a Free consultation</h3>
        </div>
        <div className='container'>
          <div className='row' id='rC'>
            <div className='col' >
              <div className='kl'>
                <img src={umang} width={'350px'} height={'350px'} alt="contact us" />
              </div>
            </div>
            <div className='col' style={{ marginLeft: '100px' }}>
              <form ref={form} className="form" onSubmit={sendEmail}>
                <div className='row'>
                  <div className="col form-group">
                    <label htmlFor="name" style={{ color: 'white' }}>Your Name (Required)</label>
                    <input type="text" id="name" name="name" placeholder="Enter your name" required />
                  </div>
                  <div className="col form-group">
                    <label htmlFor="email" style={{ color: 'white', alignContent:'start' }}>Your Email (Required)</label>
                    <input type="email" id="email" name="email" placeholder="Enter your email" required />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="phone" style={{ color: 'white' }}>Phone (Optional)</label>
                  <input type="tel" id="phone" name="phone" placeholder="Enter your phone number" />
                </div>
                <div className="form-group">
                  <label htmlFor="requirement" style={{ color: 'white' }}>Tell Us About Your Requirement</label>
                  <textarea id="requirement" name="requirement" rows="4" placeholder="Describe your needs in detail"></textarea>
                </div>
                <button type="submit" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Contact Us
                  <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default MidContactUs
